import { z } from "zod";
import { ReportSettingRowVisibility } from "@common/types/reports/report-settings";
import { numberFormatValuesSchema } from "./number-format-setting.schema";

export const reportPresentationChromeSchema = z.object({
    header: z.string(),
    title: z.string(),
    subtitle: z.string(),
    subtitle2: z.string(),
    footer: z.string(),
    memo: z.string(),
    watermarkText: z.string(),
});
export type ReportPresentationChrome = z.infer<
    typeof reportPresentationChromeSchema
>;

export const reportPresentationSchema = z.object({
    chrome: reportPresentationChromeSchema,
    rowVisibility: z.nativeEnum(ReportSettingRowVisibility),
    numberFormat: numberFormatValuesSchema,
});
export type ReportPresentation = z.infer<typeof reportPresentationSchema>;

/**
 * Report schemas keep `presentation` optional because export payloads and
 * pre-attachment values omit it. HTTP responses always carry it, so contracts
 * derive their response schema through this.
 */
export const withRequiredPresentation = <TShape extends z.ZodRawShape>(
    base: z.ZodObject<TShape>,
) => base.extend({ presentation: reportPresentationSchema });
